import confetti from 'canvas-confetti';

interface CelebrateProps {
  zIndex?: number;
}

export const celebrate = ({ zIndex = 99 }: CelebrateProps = {}): void => {
  const duration = 1500;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 1500, ticks: 100, zIndex };

  const interval: NodeJS.Timeout = setInterval((): void => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }
    const particleCount = 20 * (timeLeft / duration);
    // since particles fall down, start a bit higher than random
    confetti({ ...defaults, particleCount, origin: { x: 0.0, y: -0.1 } });
    confetti({ ...defaults, particleCount, origin: { x: 0.35, y: -0.1 } });
    confetti({ ...defaults, particleCount, origin: { x: 0.7, y: -0.1 } });
    confetti({ ...defaults, particleCount, origin: { x: 1, y: -0.1 } });
  }, 50);
};

interface FireOptions {
  spread: number;
  startVelocity?: number;
  decay?: number;
  scalar?: number;
}

export const fireworks = (x?: number, y?: number): void => {
  const count = 200;
  const defaults = {
    origin: { x, y: y || 0.7 },
  };

  function fire(particleRatio: number, options: FireOptions) {
    confetti({ ...defaults, ...options, particleCount: Math.floor(count * particleRatio) });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  fire(0.2, {
    spread: 60,
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};
